module.exports = __webpack_public_path__ + "img/20.04768bcd.png";